import {
  Box,
  Typography,
} from "@mui/material";
import CustomInput from "../../../components/inputs/CustomInput";

const OrderShipUI = ({ fields, loading, setFields, params, setLoading }) => {
  return (
    <Box position="relative" overflow="hidden" height={"100%"} width="100%">
      <Typography color="red" variant="h4">
        {fields?.err}
      </Typography>
      
      <CustomInput
        loading={loading}
        disabled={loading}
        value={fields?.reason}
        onChange={(e) =>
          setFields({ ...fields, err: "", reason: e.target.value })
        }
        rows={2}
        multiline
        type="text"
        label={"Reason*"}
      />
    </Box>
  );
};

export default OrderShipUI;
